import(/* webpackMode: "eager" */ "/codebuild/output/src629200581/src/top-ten/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src629200581/src/top-ten/src/app/globals.css");
